export default "__VITE_ASSET__BaHbRX4$__"